
const balanceadorMetadataConfig = {
    _metainfoVersion: 51,

    id: "BarColoring2@tv-basicstudies-1",
    name: "Balanceador Toolbox",
    description: "Balanceador Toolbox",
    shortDescription: "Balanceador Toolbox",

    isCustomIndicator: true,
    is_price_study: true,

    format: {
        type: 'price',
        precision: 4,
    },

    defaults: {
        styles: {
            plot_0: { // Banda superior
                linestyle: 1,
                visible: true,

                // Make the line thinner
                linewidth: 1.5,

                // Plot type is Line
                plottype: 0,

                // Show price line
                trackPrice: false,

                // Set the plotted line color to dark red
                color: 'rgb(0, 122, 255)'
            },
            plot_1: { // Banda Media
                linestyle: 0,
                visible: true,

                // Make the line thinner
                linewidth: 2.5,

                // Plot type is Line
                plottype: 0,

                // Show price line
                trackPrice: false,

                // Set the plotted line color to dark red
                color: 'rgb(0, 122, 255)'
            },
            plot_2: { // Banda Inferior
                linestyle: 1,
                visible: true,
                extendLeft: false,
                extendRight: false,
                // Make the line thinner
                linewidth: 1.5,

                // Plot type is Line
                plottype: 0,

                // Show price line
                trackPrice: false,

                // Set the plotted line color to dark red
                color: 'rgb(0, 122, 255)'
            }
        },

        inputs: {},

    },
    inputs: [],
    plots: [{ id: 'plot_0', type: 'line' }, { id: "plot_1", type: "line" },
    { id: "plot_2", type: "line" }],
    palettes: {
        palette_0: {
            colors: [
                { name: 'Color 0' },
                { name: 'Color 1' }
            ],

            valToIndex: {
                100: 0,
                200: 1
            }
        }
    }

};

const averagePriceMetadataConfig = {
    _metainfoVersion: 51,

    id: "BarColoring3@tv-basicstudies-1",
    name: "QRT AVERAGE PRICE",
    description: "QRT AVERAGE PRICE",
    shortDescription: "QRT AVERAGE PRICE",

    isCustomIndicator: true,
    is_price_study: true,

    format: {
        type: 'price',
        precision: 4,
    },

    defaults: {
        styles: {
            plot_0: { // Banda medial (VWAP)
                linestyle: 0,
                visible: true,
                linewidth: 2,
                plottype: 2,
                trackPrice: false,
                color: 'rgb(255, 255, 255)'
            },
            plot_1: { // Banda superior 1 (+1)
                linestyle: 0,
                visible: true,
                linewidth: 1,
                plottype: 2,
                trackPrice: false,
                color: 'rgba(255, 255, 255, 0.7)'
            },
            plot_2: { // Banda superior 2 (+2)
                linestyle: 0,
                visible: true,
                linewidth: 1,
                plottype: 2,
                trackPrice: false,
                color: 'rgba(255, 255, 255, 0.5)'
            },
            plot_3: { // Banda inferior 1 (-1)
                linestyle: 0,
                visible: true,
                linewidth: 1,
                plottype: 2,
                trackPrice: false,
                color: 'rgba(255, 255, 255, 0.7)'
            },
            plot_4: { // Banda inferior 2 (-2)
                linestyle: 0,
                visible: true,
                linewidth: 1,
                plottype: 2,
                trackPrice: false,
                color: 'rgba(255, 255, 255, 0.5)'
            },
            plot_5: { // Banda superior extra (+3)
                linestyle: 0,
                visible: true,
                linewidth: 1,
                plottype: 2,
                trackPrice: false,
                color: 'rgba(255, 255, 255, 0.5)'
            },
            plot_6: { // Banda inferior extra (-3)
                linestyle: 0,
                visible: true,
                linewidth: 1,
                plottype: 2,
                trackPrice: false,
                color: 'rgba(255, 255, 255, 0.7)'
            }
        },

        inputs: {},

    },
    inputs: [],
    plots: [
        { id: 'plot_0', type: 'line' },
        { id: 'plot_1', type: 'line' },
        { id: 'plot_2', type: 'line' },
        { id: 'plot_3', type: 'line' },
        { id: 'plot_4', type: 'line' },
        { id: 'plot_5', type: 'line' },
        { id: 'plot_6', type: 'line' }
    ],
    palettes: {
        palette_0: {
            colors: [
                { name: 'Color 0' },
                { name: 'Color 1' }
            ],

            valToIndex: {
                100: 0,
                200: 1
            }
        }
    }

};
const trendStrengthMetadataConfig = {
    _metainfoVersion: 51,
    id: 'ComplexFilledAreas@tv-basicstudies-1',
    description: 'Trend Strength',
    shortDescription: 'Trend Strength',
    is_price_study: false,
    isCustomIndicator: true,
    plots: [
        {
            id: 'plot_0',
            type: 'line',
        },
        {
            id: 'plot_1',
            type: 'line',
        },
        {
            id: "zero_line",
            type: "line"
        },
        {
            id: 'plot_2',
            type: 'colorer',
            target: 'filledAreaId1',
            palette: 'paletteId1',
        },
    ],

    filledAreas: [
        {
            id: 'filledAreaId1',
            objAId: 'zero_line',
            objBId: 'plot_1',
            title: 'Filled area between first and second plot',
            type: 'plot_plot',
            palette: 'paletteId1',
        },
    ],

    palettes: {
        paletteId1: {
            valToIndex: {
                0: 0,
                1: 1,
            },
            colors: {
                0: {
                    name: 'First color',
                },
                1: {
                    name: 'Second color',
                },
            },
        },
    },
    defaults: {
        filledAreasStyle: {
            filledAreaId1: {
                color: 'yellow',
                visible: true,
                transparency: 50,
            },
        },

        palettes: {
            paletteId1: {
                colors: {
                    0: {
                        color: 'green',
                        width: 1,
                        style: 0,
                    },
                    1: {
                        color: 'red',
                        width: 3,
                        style: 1,
                    },
                },
            },
        },

        styles:
        {
            plot_0: {
                linestyle: 0,
                visible: true,
                linewidth: 1,
                plottype: 5,
                trackPrice: false,
                color: '#00BFFF'
            },
            zero_line: {
                linestyle: 0,
                visible: false,
                linewidth: 1,
                plottype: 5,
                trackPrice: false,
                color: 'white'
            },
            plot_1: {
                linestyle: 0,
                visible: true,
                linewidth: 1,
                plottype: 0,
                trackPrice: false,
                color: 'yellow'
            },
        },
        precision: 4,
        inputs: {}
    },
    styles:
    {
        plot_0:
        {
            title: 'First plot',
            histogramBase: 0,
        },
        plot_1:
        {
            title: 'Second plot',
            histogramBase: 0,
        },
    },
    inputs: [],
    format: {
        type: 'price',
        precision: 4,
    },
};
const volumeTakerSideMetadataConfig = {
    _metainfoVersion: 51,
    id: 'ComplexFilledArea1s@tv-basicstudies-1',
    description: 'Volume Taker side',
    shortDescription: 'Volume Taker side',
    is_price_study: false,
    isCustomIndicator: true,
    plots: [

        {
            id: 'plot_1',
            type: 'line',
        },
        {
            id: "zero_line",
            type: "line"
        },
        {
            id: 'plot_2',
            type: 'colorer',
            target: 'filledAreaId1',
            palette: 'paletteId1',
        },
    ],

    filledAreas: [
        {
            id: 'filledAreaId1',
            objAId: 'zero_line',
            objBId: 'plot_1',
            title: 'Filled area between first and second plot',
            type: 'plot_plot',
            palette: 'paletteId1',
        },
    ],

    palettes: {
        paletteId1: {
            valToIndex: {
                0: 0,
                1: 1,
            },
            colors: {
                0: {
                    name: 'First color',
                },
                1: {
                    name: 'Second color',
                },
            },
        },
    },
    defaults: {
        filledAreasStyle: {
            filledAreaId1: {
                color: 'pink',
                visible: true,
                transparency: 50,
            },
        },

        palettes: {
            paletteId1: {
                colors: {
                    0: {
                        color: 'blue',
                        width: 1,
                        style: 0,
                    },
                    1: {
                        color: 'orange',
                        width: 3,
                        style: 1,
                    },
                },
            },
        },

        styles:
        {
            zero_line: {
                linestyle: 0,
                visible: false,
                linewidth: 1,
                plottype: 5,
                trackPrice: false,
                color: 'white'
            },
            plot_1: {
                linestyle: 0,
                visible: true,
                linewidth: 1,
                plottype: 0,
                trackPrice: false,
                color: 'pink'
            },
        },
        precision: 4,
        inputs: {}
    },
    styles:
    {

        plot_1:
        {
            title: 'Second plot',
            histogramBase: 0,
        },
    },
    inputs: [],
    format: {
        type: 'price',
        precision: 4,
    },
};
const atrModelMetadataConfig = {
    _metainfoVersion: 51,

    id: "BarColoring@tv-basicstudies-1",
    name: "ATR MODEL",
    description: "ATR Model",
    shortDescription: "ATR MODEL",

    isCustomIndicator: true,
    is_price_study: true,

    format: {
        type: 'price',
        precision: 4,
    },

    defaults: {
        styles: {
            plot_0: {
                linestyle: 1,
                visible: true,

                // Make the line thinner
                linewidth: 1,

                // Plot type is Line
                plottype: 2,

                // Show price line
                trackPrice: false,

                // Set the plotted line color to dark red
                color: 'rgba(255,0,0,1)'
            },
            plot_1: {
                linestyle: 0,
                visible: true,

                // Make the line thinner
                linewidth: 1,

                // Plot type is Line
                plottype: 2,

                // Show price line
                trackPrice: false,

                // Set the plotted line color to dark red
                color: 'rgba(255,0,0,1)'
            },
            plot_2: {
                linestyle: 0,
                visible: true,

                // Make the line thinner
                linewidth: 2,

                // Plot type is Line
                plottype: 2,

                // Show price line
                trackPrice: false,

                // Set the plotted line color to dark red
                color: 'rgba(255,0,0,1)'
            },
            plot_3: {
                linestyle: 1,
                visible: true,

                // Make the line thinner
                linewidth: 1,

                // Plot type is Line
                plottype: 2,

                // Show price line
                trackPrice: false,

                // Set the plotted line color to dark red
                color: 'rgba(0,255,0,1)'
            },
            plot_4: {
                linestyle: 0,
                visible: true,

                // Make the line thinner
                linewidth: 1,

                // Plot type is Line
                plottype: 2,

                // Show price line
                trackPrice: false,

                // Set the plotted line color to dark red
                color: 'rgba(0,255,0,1)'
            },
            plot_5: {
                linestyle: 0,
                visible: true,

                // Make the line thinner
                linewidth: 2,

                // Plot type is Line
                plottype: 2,

                // Show price line
                trackPrice: false,

                // Set the plotted line color to dark red
                color: 'rgba(0,255,0,1)'
            }
        },

        inputs: {}
    },
    inputs: [],
    plots: [{ id: 'plot_0', type: 'line' }, { id: "plot_1", type: "line" },
    { id: 'plot_2', type: 'line' }, { id: "plot_3", type: "line" },
    { id: 'plot_4', type: 'line' }, { id: "plot_5", type: "line" }],
    palettes: {
        palette_0: {
            colors: [
                { name: 'Color 0' },
                { name: 'Color 1' }
            ],

            valToIndex: {
                100: 0,
                200: 1
            }
        }
    }
};

const buscarPorFecha = (fecha, datos) => {
    return datos.find(item => item.fecha === fecha);
};
const buscarPorDatetime = (fecha, datos) => {
    return datos.find(item => item.Datetime === fecha);
};
const atrMath = (
    fecha,
    atrData,
) => {
    fecha = `${fecha.getFullYear()}-${(fecha.getMonth() + 1) < 10 ? "0" + String(fecha.getMonth() + 1) : String(fecha.getMonth() + 1)}-${fecha.getDate() < 10 ? "0"
        + String(fecha.getDate()) : fecha.getDate()
        }T${fecha.getHours() < 10 ? "0" + String(fecha.getHours()) : fecha.getHours()}:${fecha.getMinutes() < 10 ? "0" + String(fecha.getMinutes()) : fecha.getMinutes()}:00`;
    let value = buscarPorFecha(fecha, atrData["atr"])


    let bz
    let sz
    let yesterday_atr
    let at_vol = 0.4
    if (value === undefined) {
        return []
    }
    bz = value.bz // hh
    sz = value.sz // ll 
    yesterday_atr = value.yesterday_atr
    if (bz === null || sz === null) {
        return []
    }
    if (yesterday_atr === null || yesterday_atr === 0) {
        return []
    }


    return [sz + yesterday_atr, sz + (1 + at_vol) * yesterday_atr,
    sz + (1 + 2 * at_vol) * yesterday_atr, bz - yesterday_atr, bz - (1 + at_vol) * yesterday_atr, bz - (1 + 2 * at_vol) * yesterday_atr]

}

const balanceadorMath = (fecha, toolboxData) => {
    fecha = `${fecha.getFullYear()}-${(fecha.getMonth() + 1) < 10 ? "0" + String(fecha.getMonth() + 1) : String(fecha.getMonth() + 1)}-${fecha.getDate() < 10 ? "0"
        + String(fecha.getDate()) : fecha.getDate()
        }T${fecha.getHours() < 10 ? "0" + String(fecha.getHours()) : fecha.getHours()}:${fecha.getMinutes() < 10 ? "0" + String(fecha.getMinutes()) : fecha.getMinutes()}:00`;


    var result = buscarPorFecha(fecha, toolboxData["balanceador"])

    if (result === undefined) {
        return [];
    }


    var midBand = (result["upper_band"] + result["lower_band"]) / 2;
    return [result["lower_band"], midBand, result["upper_band"]];
}
// const REGIME_STATS = {
//     "Alta Volatilidad": {
//         "M1": { up: 0.165539, down: -0.156252 },
//         "M2": { up: 0.240062, down: -0.232657 },
//         "M3": { up: 0.337884, down: -0.327392 }
//     },
//     "Baja Volatilidad": {
//         "M1": { up: 0.070763, down: -0.070601 },
//         "M2": { up: 0.102338, down: -0.100687 },
//         "M3": { up: 0.143631, down: -0.143431 }
//     },
//     "Volatilidad Media": {
//         "M1": { up: 0.101482, down: -0.103754 },
//         "M2": { up: 0.148737, down: -0.146710 },
//         "M3": { up: 0.212927, down: -0.210678 }
//     }
// };

const avgPriceMath = (fecha, toolboxData) => {
    var hora = fecha.getHours()
    var minutos = fecha.getMinutes()
    fecha = `${fecha.getFullYear()}-${(fecha.getMonth() + 1) < 10 ? "0" + String(fecha.getMonth() + 1) : String(fecha.getMonth() + 1)}-${fecha.getDate() < 10 ? "0"
        + String(fecha.getDate()) : fecha.getDate()
        }T${hora < 10 ? "0" + String(hora) : hora}:${minutos < 10 ? "0" + String(minutos) : minutos}:00`;



    var result = buscarPorFecha(fecha, toolboxData["avgPrice"])
    console.log(result)
    if (result === undefined) {
        return [];
    }

    // Determine Module (M1, M2, M3)

    var midBand = result["value"]
    var upper_1 = result["up05"]
    var upper_2 = result["up075"]
    var upper_3 = result["up09"]
    var lower_1 = result["down05"]
    var lower_2 = result["down075"]
    var lower_3 = result["down09"]
    console.log(midBand, upper_1, upper_2, upper_3, lower_1, lower_2, lower_3)
    return [midBand, upper_1, upper_2, upper_3, lower_1, lower_2, lower_3];
}
const trendStrengthMath = (fecha, toolboxData) => {
    fecha = `${fecha.getFullYear()}-${(fecha.getMonth() + 1) < 10 ? "0" + String(fecha.getMonth() + 1) : String(fecha.getMonth() + 1)}-${fecha.getDate() < 10 ? "0"
        + String(fecha.getDate()) : fecha.getDate()
        }T${fecha.getHours() < 10 ? "0" + String(fecha.getHours()) : fecha.getHours()}:${fecha.getMinutes() < 10 ? "0" + String(fecha.getMinutes()) : fecha.getMinutes()}:00`;
    var result = buscarPorDatetime(fecha, toolboxData["polarizador"])
    var resultFuerza = buscarPorFecha(fecha, toolboxData["fuerza"])
    // console.log("fuerza",resultFuerza)
    if ((result === undefined) || (resultFuerza === undefined)) {
        return [];
    }

    var fuerzaValue = resultFuerza["force"];
    var polarizadorValue = result["TS_INDEX"];
    // var value = Math.random() * 200 - 100;
    var colorIndex = polarizadorValue > 0 ? 0 : 1;

    return [fuerzaValue, polarizadorValue, 0, colorIndex];
}
const volumeTakerSideMath = (fecha, toolboxData) => {
    fecha = `${fecha.getFullYear()}-${(fecha.getMonth() + 1) < 10 ? "0" + String(fecha.getMonth() + 1) : String(fecha.getMonth() + 1)}-${fecha.getDate() < 10 ? "0"
        + String(fecha.getDate()) : fecha.getDate()
        }T${fecha.getHours() < 10 ? "0" + String(fecha.getHours()) : fecha.getHours()}:${fecha.getMinutes() < 10 ? "0" + String(fecha.getMinutes()) : fecha.getMinutes()}:00`;
    var result = buscarPorFecha(fecha, toolboxData["takerSide"])
    // console.log("fuerza",resultFuerza)
    if ((result === undefined)) {
        return [];
    }

    // var fuerzaValue = resultFuerza["force"];
    var polarizadorValue = result["value"];
    // var value = Math.random() * 200 - 100;
    var colorIndex = polarizadorValue > 0 ? 0 : 1;

    return [polarizadorValue, 0, colorIndex];
}
export {
    balanceadorMetadataConfig, averagePriceMetadataConfig,
    trendStrengthMetadataConfig, volumeTakerSideMetadataConfig, atrModelMetadataConfig,
    atrMath, balanceadorMath, avgPriceMath, trendStrengthMath, volumeTakerSideMath
};